//
//
//
//
//
//
//
//
//
//
//
//

/**
 * PreviewBanner is purely informational: it tells the editor they are
 * viewing draft content and when the preview token expires.
 *
 * Exit is intentionally NOT handled here. Strapi's preview UI provides
 * the close (X) widget which returns the editor to the Content Manager.
 * Duplicating that here was both redundant and caused an oscillation
 * loop with the Strapi preview iframe (exit -> Strapi 404 -> re-enter
 * preview -> banner -> exit -> ...).
 */
export default {
  name: 'PreviewBanner',
  computed: {
    isPreview () {
      return !!this.$store.getters['preview/isPreview']
    },
    expiresAt () {
      return this.$store.state.preview.expiresAt || 0
    },
    expiresLabel () {
      if (!this.expiresAt) return ''
      try {
        const d = new Date(this.expiresAt)
        const hh = String(d.getHours()).padStart(2, '0')
        const mm = String(d.getMinutes()).padStart(2, '0')
        // If expiry is on a different calendar day from "now" (typical for
        // a 24h TTL), include a short date so "12:27" is not mistaken for
        // "in a few minutes".
        const now = new Date()
        const sameDay =
          d.getFullYear() === now.getFullYear() &&
          d.getMonth() === now.getMonth() &&
          d.getDate() === now.getDate()
        if (sameDay) return `${hh}:${mm}`
        const dd = String(d.getDate()).padStart(2, '0')
        const mo = String(d.getMonth() + 1).padStart(2, '0')
        return `${hh}:${mm} on ${dd}/${mo}`
      } catch (e) {
        return ''
      }
    }
  }
}
